import { FC } from 'react';
import { Hr } from 'src/components/_commons';
import { notificationTypes } from '@monorepo/helpers';
import { typeNotificationType } from '@monorepo/models';

type propsType = {
    type: typeNotificationType;
};

export const NotificationsTitle: FC<propsType> = ({ type }) => {

    return (
        <>
        <div className={'mt-5'}>
            <Hr />
        </div>
        <div className={'my-5'}>
            <h2 className={'text-center'}>
                {notificationTypes.find(nt => nt.type === type)?.label.toUpperCase()}
            </h2>
        </div>
        </>
    );
}
